module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio56-775f4b3d0ffbf7a51ce79f77f3feff08.m4a";